import React, {useContext} from "react";
import Button from "@mui/material/Button";
import {ContentContext} from "../../ContentContext";
import {getDirectusImage} from "../../api/directus";

function HeaderImage() {
    const data = useContext(ContentContext);
    const headerImageUrl = getDirectusImage(data?.headerImage);
    const headerThumbnailUrl = getDirectusImage(data?.headerThumbnail);

    const style = {
        backgroundImage: `url(${headerImageUrl})`,
        backgroundPosition: data?.headerImagePosition || "center",
    };

    return (
        <div className={"header-image fade-in"} style={style}>
            <div className={"overlay"}></div>
            <div className={"header-image-content-wrapper"}>
                <div className={"header-image-content"}>
                    <div className={"header-image-title"} dangerouslySetInnerHTML={{__html: data?.headerTitle}} />
                    <Button
                        className={"header-image-cta button hover-move"}
                        href={data?.headerCtaUrl || null}
                        target={"_blank"}
                        rel="noreferrer"
                        onClick={() => window.umami?.track("Header Click", { label: data?.headerCtaText })}
                    >
                        {data?.headerCtaText}
                    </Button>
                </div>
                <div className={"header-image-thumbnail"}>
                    <img src={headerThumbnailUrl} alt={"header-image"} loading={"lazy"} />
                </div>
            </div>
        </div>
    );
}

export default HeaderImage;
